export default "static/media/logo.4e414f8.png"